import Main from "feature/main/main";
import {MainProvider} from "feature/main/use-main";
import React from "react";

const MainContext = () => {
  return (
    <MainProvider>
      <Main />
    </MainProvider>
  );
};

export default MainContext;
